import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectAppConfig } from '../redux/appConfigReducer';

const TITLE_KEYS = {
  military: 'digitalLeads.inputs.militaryTitle',
  schedService: 'digitalLeads.inputs.schedServiceTitle',
  eventTOR: 'digitalLeads.inputs.eventTORTitle',
  eventMTL: 'digitalLeads.inputs.eventMTLTitle',
  eventVAN: 'digitalLeads.inputs.eventVANTitle',
  eventEDM: 'digitalLeads.inputs.eventEDMTitle',
};

const useGetFormTitle = () => {
  const { t } = useTranslation();
  const { formTitle, presetForm } = useSelector(selectAppConfig);

  const translationKey = TITLE_KEYS[presetForm as keyof typeof TITLE_KEYS];
  const finalFormTitle = translationKey ? t(translationKey) : formTitle;

  return { finalFormTitle };
};

export default useGetFormTitle;
